export default "__VITE_ASSET__8Im1GqEL__"